// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q3as","controls":"styles_controls__39RLG","charLimit":"styles_charLimit__sh6GI","input":"styles_input__2bGcV","send":"styles_send__3iNsJ"};